import { Component } from '@angular/core';
import { CurrentProductService, ICON_TYPE } from '@spartacus/storefront';

@Component({
  selector: 'app-custom-product-summary',
  standalone: false,
  templateUrl: './custom-product-summary.component.html',
  styleUrls: ['./custom-product-summary.component.scss'],
})
export class CustomProductSummaryComponent {
  constructor(private currentProductService: CurrentProductService) {}

  product$ = this.currentProductService.getProduct();
  iconTypes = ICON_TYPE;
}
